var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPrefixRedirGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "r6utfdydoa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.713725 0 0 0 0 0.749020 0 0 0 0 0.807843 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#r6utfdydoa)",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#B6BFCE"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M14 12v3H5V6h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 5.5-6 6"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M10.5 5.5h4v4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPrefixRedirGray);
export default __webpack_public_path__ + "static/media/ico-prefix-redir-gray.2cfe4a66666c44a6d629cb96861f2be8.svg";
export { ForwardRef as ReactComponent };